import { styled } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { createElement } from 'react';
import '../utilities/get-styleprop.js';
import { b as _extends, _ as _objectWithoutProperties } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import 'react-dom';
import '../ClickOutside/ClickOutside.js';
import '../Tooltip/Tooltip.js';
import '../Button/Button.js';
import 'react-popper';
import '../DropdownMenu/DropdownMenu.js';
import '../DropdownMenu/Item.js';
import '../DropdownMenu/Divider.js';
import './constants.js';
import { getContentWidth } from './utils.js';
import { colors } from './colors.js';
import Group from './Group/Group.js';
import './Item/FavoriteStar.js';
import './Item/ItemDropdown.js';
import Item from './Item/Item.js';
import EmptyPlaceholder from './EmptyPlaceholder/EmptyPlaceholder.js';

const ContentWrapper = styled(Div)`
  background-color: ${colors.background};
  padding: ${({
  theme
}) => 2 * theme.spacing.md}px 0 0
    ${({
  theme
}) => 2 * theme.spacing.md}px;
  flex: 1;
  overflow: auto;
`;

const _excluded = ["id", "path"];
const Content = ({
  groups,
  componentLabels,
  onMarkFavorite,
  onUnmarkFavorite,
  checkIfFavorite,
  onItemClick,
  styles = {}
}) => {
  const isEmpty = groups.length === 0;
  const contentWidth = getContentWidth(groups);
  return /*#__PURE__*/createElement(ContentWrapper, _extends({
    width: `${contentWidth}px`
  }, styles.root), isEmpty ? /*#__PURE__*/createElement(EmptyPlaceholder, {
    label: componentLabels.noResultsFound
  }) : groups.map(({
    title: groupTitle,
    items,
    id: groupId,
    iconProps
  }) => {
    return /*#__PURE__*/createElement(Group, {
      title: groupTitle,
      key: groupId,
      iconProps: iconProps
    }, items.map(item => {
      const {
          id: itemId,
          path
        } = item,
        rest = _objectWithoutProperties(item, _excluded);
      return /*#__PURE__*/createElement(Item, _extends({
        key: itemId,
        onClick: () => onItemClick(path)
      }, rest, {
        isFavorite: checkIfFavorite(item),
        onMarkFavorite: () => {
          onMarkFavorite(item);
        },
        onUnmarkFavorite: () => {
          onUnmarkFavorite(item);
        },
        markFavoriteLabel: componentLabels.markFavorite,
        unmarkFavoriteLabel: componentLabels.unmarkFavorite
      }));
    }));
  }));
};

export default Content;
